export const DEFAULT_DIR_IGNORE_LIST = ['node_modules', '.git'];
